import React from 'react'
import PropTypes from 'prop-types'

import styles from './LineClamp.css'

class LineClamp extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        lines: PropTypes.number.isRequired,
    }

    hasOverflow = () => {
        return this._base.clientHeight < this._inner.scrollHeight
    }

    render() {
        const style = {
            display: '-webkit-box',
            WebkitLineClamp: this.props.lines,
            WebkitBoxOrient: 'vertical',
        }

        return (
            <div
                className={styles.base}
                style={style}
                ref={c => this._base = c}
            >
                <div ref={c => this._inner = c}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default LineClamp



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/LineClamp/LineClamp.jsx